exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-element[data-v-28b74450]{display:block;position:relative;overflow:hidden;z-index:1;width:100%}.fade-element.full-width[data-v-28b74450]{width:100%;height:100%}", ""]);

// exports
